import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
  name: 'MdCheckbox',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    disabled: Boolean,
    label: String,
    required: Boolean,
    submitted: Boolean,
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {

    const content = computed({
      get() {
        return props.modelValue;
      },
      set(newValue) {
        if (!props.disabled) {
          emit('update:modelValue', newValue);
          if (input.value.value) {
            input.value.classList.remove('error');
          }
        }
      },
    });

    const isRequired = computed(() => {
      return props.required && !props.modelValue && props.submitted;
    });

    const input = ref(null);
    
    const toggle = () => {
      content.value = !content.value;
    };

    return {
      input,
      content,
      isRequired,
      toggle,
    };
  },
});